import { Component, OnInit, Input, ChangeDetectorRef, ViewContainerRef, ComponentFactoryResolver, OnChanges } from '@angular/core';
import { ContentManager } from '../content-manager';
import { AudioSettingComponent } from './audio-setting/audio-setting.component';

declare var jsPanel: any;

@Component({
    selector: 'chatbot-audio',
    templateUrl: './audio.component.html',
    styleUrls: ['./audio.component.less']
})
export class AudioComponent implements OnInit, OnChanges {

    @Input() content: ContentManager;

    voiceIndex: number = 0;
    voiceList: any[] = [];
    activeVoice: any = null;
    isAudioOn: boolean = false;

    jsPanelPopup: any;


    get panelWidth() {
        return Math.min(560, window.innerWidth * 0.9);
    }

    get panelHeight() {
        return Math.min(240, window.innerHeight * 0.9);
    }

    get jsPanelContentHeight() {
        return document.getElementsByClassName("jsPanel-content")[0].clientHeight;
    }

    get isSpeechSynthesis() {
        return 'speechSynthesis' in window;
    }

    constructor(private cd: ChangeDetectorRef,
        private vcr: ViewContainerRef,
        private resolver: ComponentFactoryResolver) {
    }

    ngOnInit() {
        if (this.isSpeechSynthesis) {
            let component = this;
            //component.getVoices();
            speechSynthesis.onvoiceschanged = function () {
                component.getVoices();
            }
        }
    }

    ngOnChanges() {
        this.content.setSynthVoiceSetting(this.isAudioOn, this.activeVoice, false);
    }

    getVoices() {
        let component = this;
        if (component.voiceList.length === 0) {
            speechSynthesis.getVoices().forEach(function (voice, index) {
                component.voiceList.push(voice);
            });
            this.setSynthVoiceSetting();
        }
    }

    getSelectedVoice() {
        if (this.voiceList.length) {
            return this.voiceList[this.voiceIndex];
        } else {
            return null;
        }
    }

    toggleAudio() {
        this.isAudioOn = !this.isAudioOn;
        this.setSynthVoiceSetting();
    }

    setSynthVoiceSetting() {
        this.activeVoice = this.getSelectedVoice();
        this.content.setSynthVoiceSetting(this.isAudioOn, this.activeVoice, true);
    }

    openAudioSetting() {
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        let component = this;
        // Code for get html element from component
        const factory = this.resolver.resolveComponentFactory(AudioSettingComponent);
        const componentRef = this.vcr.createComponent(factory);
        const element = componentRef.location.nativeElement;
        componentRef.instance.voiceIndex = component.voiceIndex;
        componentRef.instance.voiceList = component.voiceList;

        this.jsPanelPopup = jsPanel.create({
            theme: 'dark',
            headerControls: {
                smallify: 'remove',
                minimize: 'remove',
                normalize: 'remove',
                maximize: 'remove'
            },
            footerToolbar: [
                '<button type="button" class="btn btn-sm btn-danger mr-2" data-type="close">Stornieren</button>',
                '<button type="button" class="btn btn-sm btn-success" data-type="ok">Update</button>'
            ],
            panelSize: {
                width: () => { return component.panelWidth; },
                height: () => { return component.panelHeight; }
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: 'Audio Setting',
            onwindowresize: true,
            dragit: false,
            resizeit: false,
            content: element,
            callback: function (panel) {
                // Footer button Functionality
                for (const btn of panel.footer.querySelectorAll('button')) {
                    btn.addEventListener('click', (e) => {
                        var dataType = e.target.getAttribute("data-type");
                        switch (dataType) {
                            case "ok":
                                component.voiceIndex = componentRef.instance.voiceIndex;
                                component.setSynthVoiceSetting();
                                panel.close();
                                break;
                            default:
                                panel.close();
                                break;
                        }
                    });
                }
            }
        });
        this.jsPanelPopup.header.style.backgroundColor = "#0891ec";
    }
}
